// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".VG1XR{-ms-flex:1 1;flex:1 1;max-width:33.33%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;margin-left:1rem}@media(max-width:1023px){.VG1XR{-ms-flex:0 1;flex:0 1;margin-left:0}}._1LfDO{height:100%}.CvINE{position:relative}._1BzX3{padding-bottom:1rem;margin-top:2.5rem}._2I0pn{margin-top:1rem}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "VG1XR",
	"content": "_1LfDO",
	"playList": "CvINE",
	"paymentOption": "_1BzX3",
	"getFreeTrial": "_2I0pn"
};
module.exports = exports;
